'use client';

import { Anchor as HeadlessAnchor } from '@zillow/constellation-headless/components/anchor/anchor';
import { forwardRef } from 'react';

import { css, cx, splitResponsiveVariant } from '@/styled-system/css';

import { anchorRecipe } from './styles/anchor.styles';
import type { AnchorPropsInterface } from './types/anchor.types';

/**
 * @since 6.0.0
 */

export const Anchor = forwardRef<HTMLAnchorElement, AnchorPropsInterface>(
  (props: AnchorPropsInterface, forwardedRef) => {
    const { onImpact, className, css: cssProp, ...rest } = props;

    const variants = splitResponsiveVariant('onImpact', onImpact);
    const styles = css(anchorRecipe.raw(variants), cssProp);

    return (
      <HeadlessAnchor
        ref={forwardedRef}
        className={cx('c11n', 'c11n_anchor', 'c11n-semantic', styles, className)}
        {...rest}
      />
    );
  },
);

Anchor.displayName = 'Anchor';
